var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"py-2 mb-0 font-medium text-center"},[_c('span',[_vm._v(" "+_vm._s(((_vm.moment(_vm.delay.time).format('DD-MMMM-YYYY')) + " " + (_vm.moment(_vm.delay.time).format('hh:mm'))))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }